import { Car, getCarDriveTypeLabel, getCarEngineTypeLabel, getCarTransmissionTypeLabel } from '@/types/car.type.ts';
import { numberFormat } from '@/utils/NumberFormatter.ts';

export function getCarSpecification(car: Car): string {
    const formatedEngineVolume = numberFormat(car.engine_volume, { decimals: 1 });
    const formatedMileage = numberFormat(car.mileage);

    const specificationItems: string[] = [
        `${formatedEngineVolume} (${car.engine_power} л.с.)`,
        getCarEngineTypeLabel(car.engine_type).toLowerCase(),
        getCarTransmissionTypeLabel(car.transmission_type).toLowerCase(),
        `${formatedMileage} км`,
        getCarDriveTypeLabel(car.drive_type).toLowerCase(),
    ];

    return specificationItems.join(', ');
}
